import { formatCuit } from '../../utils/Masks';

export type UruguayDocumentType = 'RUT' | 'Cedula';

export const formatDocumentForSearch = (
  value: string,
  isUruguayEnabled: boolean
): string => {
  if (isUruguayEnabled) {
    return (value ?? '').replace(/\D/g, '');
  }
  return formatCuit(value);
};

export const getUruguayDocumentMaxLength = (
  type: UruguayDocumentType
): number => (type === 'RUT' ? 12 : 8);

export const isValidUruguayDocumentLength = (
  digits: string,
  type: UruguayDocumentType
): boolean => {
  const len = digits.replace(/\D/g, '').length;
  if (type === 'RUT') return len === 12;
  return len === 7 || len === 8;
};
